import { Box } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import {
    addUserFromPermission,
    getUserError,
    getUserLoading,
    getUserStatus,
    getUserSuccess,
    updateStatus,
} from "../../features/userSlice";
import UserForm from "../users/userForm";
import BackButton from "../../components/backButton";
import RestaurantAppBar from "../../components/restaurantTopBar";
import { useTranslation } from "react-i18next";

const AddUserFromPermission = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const status = useSelector(getUserStatus);
    const error = useSelector(getUserError);
    const loading = useSelector(getUserLoading);
    const success = useSelector(getUserSuccess);

    const initialValues = {
        email: "",
        firstName: "",
        lastName: "",
        role: "",
        password: "",
        confirmPassword: "",
    };

    const handleFormSubmit = (values) => {
        dispatch(
            addUserFromPermission({
                email: values.email,
                fullName: values.firstName + " " + values.lastName,
                role: values.role,
                password: values.password,
            })
        );
    };

    useEffect(() => {
        if (status === "addSuccess") {
            toast.success(success);
            dispatch(updateStatus());
            navigate("/user-permissions");
        } else if (status === "addError") {
            toast.error(error);
        }
    }, [status, error, dispatch, navigate, success]);

    return (
        <div className="main-application">
            <RestaurantAppBar />
            <Box m="20px" className="main-application">
                <BackButton />
                <Header
                    title={t("headers.addUser")}
                    subtitle={t("headers.addUserSub")}
                />
                <UserForm
                    buttonText={t("common.submit")}
                    handleFormSubmit={handleFormSubmit}
                    initialValues={initialValues}
                    loading={loading}
                />
            </Box>
        </div>
    );
};

export default AddUserFromPermission;
